<template>
    <div class="center">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div class="section section-color center" style="min-height: 308px">
            <div class="w-container" style="padding-top: 100px">
                <div class="key-number" style="color: #ffffff; font-weight: normal">{{$t('Contact_Us')}}</div>
            </div>
        </div>

        <div class="faq">
            <div class="header-text">
                <p>Find answers to some common questions here.</p>
                <p>For any other question, please use the form below to contact us.</p>
            </div>

            <div class="questions">
                <h1 class="question">I want to promote my app but I am not currently using an attribution partner</h1>
                <p class="answer">An attribution partner will not only provide you with a robust tracking and analytics platform, but they will also notify us of conversions. As we bill based on CPI metrics instead of a CPM, it is crucial that we are notified of every event to accurately optimize toward your target KPIs. At this time, starting a campaign without an attribution partner is not possible.</p>

                <h1 class="question">My app is on a different app store. Can DemandScale help promote it?</h1>
                <p class="answer">At this time, DemandScale is only configured to accept links for campaigns that will redirect users to the Google Play Store or the Apple App Store.</p>

                <h1 class="question">What is a good starting rate for my country?</h1>
                <p class="answer">While rates will vary by country, they will also vary based on the desired events that happen after install. During the campaign setup process there will be an area where payout recommendations are made based on country and billing type.</p>

                <h1 class="question">Can I promote my website / app landing page?</h1>
                <p class="answer">At this time, DemandScale is only configured to accept links for campaigns that will redirect users to the Google Play Store or the Apple App Store.</p>
            </div>
        </div>

        <div class="address-container">
            <div class="address">
                <div style="font-size: 24px;color:#0e0c1a;font-weight: bold">Sift Media</div>
                <div style="font-size: 16px">324 Blackwell Street<br>Suite 900, PMB 122<br>Durham, NC 27701</div>
            </div>
        </div>

        <div class="form">
            <form id="contactUsForm" autocomplete="on" method="POST" action="https://hb7r2q79ra.execute-api.us-east-1.amazonaws.com/contact-us/demandscale-contact-us-form-handler">
                <input type="hidden" name="Page" value="Contact Us">

                <b-field grouped>
                    <b-field :label="$t('first_name') + ' *'" style="margin-top: 0;margin-bottom: 0; width:48%">
                        <b-input type="text" name="First Name" required></b-input>
                    </b-field>

                    <b-field :label="$t('last_name') + ' *'" style="margin-top: 0;margin-bottom: 0;; width:49%">
                        <b-input type="text" name="Last Name" required></b-input>
                    </b-field>
                </b-field>

                <b-field :label="$t('email_address') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                    <b-input type="email" name="Email Address" required></b-input>
                </b-field>

                <b-field :label="$t('company') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                    <b-input type="text" name="Company" required></b-input>
                </b-field>

                <b-field :label="$t('subject') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                    <b-input type="text" name="Subject" required></b-input>
                </b-field>

                <b-field :label="$t('message') + ' *'" style="margin-top: 0;margin-bottom: 0;">
                    <b-input type="textarea" name="Message" required></b-input>
                </b-field>

                <div align="left" style="padding-bottom: 30px">
                    <button class="ds-button button-small w-button" id="submit-button" type="submit">{{$t('submit')}}</button>
                </div>
            </form>
        </div>

        <FooterMenu/>
        <CookieBar/>
    </div>
</template>

<script>
    import NetworkStatus from "../components/NetworkStatus";
    import HeaderMenu from "../components/HeaderMenu";
    import FooterMenu from "../components/FooterMenu";
    import CookieBar from "../components/CookieBar";

    export default {
        components: {
            NetworkStatus, HeaderMenu, FooterMenu, CookieBar
        }
    }
</script>

<style>
    .faq {
        margin-left: auto;
        margin-right: auto;
        max-width: 800px;
        padding-left: 1em;
        padding-right: 1em;
    }
    .header-text {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .header-text p {
        color: #636081;
    }
    .questions {
        text-align: left;
        font-size: 1.0rem;
    }
    .question {
        color: #363636;
    }
    .answer {
        color: #636081;
        margin-bottom: 30px;
    }
    h1.question {
        font-size: 1.5rem;
        text-align: left;
    }
    .address-container {
        display: inline-grid;
        grid-template-columns: auto auto;
    }
    .address {
        padding: 20px 25px 50px 25px;
    }
    .form {
        padding-left: 20px;
        padding-right: 20px;
        max-width: 550px;
        margin: auto;
    }
    .field, .control {
        text-align: left;
    }
    .label {
        color: #363636;
        background-color: #fff;
        text-align: left;
        margin-top: 0;
        margin-bottom: 0;
        padding: 0;
        display: block;
        font-size: 1rem;
        font-weight: 700;
    }
    p.help.is-danger {
        margin-top: -15px;
    }
    #submit-button {
        margin-top: 30px;
    }
</style>
